import { render, staticRenderFns } from "./ModalAsignarConsejera.vue?vue&type=template&id=74dd8069&scoped=true&"
import script from "./ModalAsignarConsejera.vue?vue&type=script&lang=js&"
export * from "./ModalAsignarConsejera.vue?vue&type=script&lang=js&"
import style0 from "./ModalAsignarConsejera.vue?vue&type=style&index=0&id=74dd8069&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dd8069",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
